import React, { Component } from 'react'
import '../styles/CartContainer.css'
import MagnifierIcon from '../images/icons/magnifier.png'
import { Link } from 'react-router-dom'
import Cart from './Cart'
import {Helmet} from "react-helmet"
import { injectIntl, defineMessages } from 'react-intl'
import MobileMenu from './MobileMenu'
import BurgerIcon from '../images/Navbar/burger.png'
import NavbarItem from './NavbarItem'
import { Cookies } from 'react-cookie-banner'

const bookingStyle = {
  position: "static",
  alignItems: "center"
}

class CartContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      sidebarRight: "-400px",
      popInDisplay: "none",
      sidebarOpacity: "0",
      mobileMenu: false,
      lang: "fr",
      bookingCheckout: true,
      backLink: "/reserver/"
    }
  }

  toggleSidebar = () => {
    if (this.state.sidebarRight === "-400px") {
      this.setState({
        sidebarRight: "0px",
        popInDisplay: "inline",
        sidebarOpacity: "1" })
    } else {
      this.setState({
        sidebarRight: "-400px",
        popInDisplay: "none",
        sidebarOpacity: "0" })
    }
  }

  toggleMobileMenu = () => {
    const menu = document.getElementById("mobile-menu-overlay")
    if (!this.state.mobileMenu) {
      this.setState({ mobileMenu: true })
      menu.style.display = "inline-block"
      window.setTimeout(x => {
        menu.style.opacity = 1
      }, 10)
    } else {
      menu.style.opacity = 0
      window.setTimeout(x => {
        menu.style.display = "none"
      }, 300)
      this.setState({ mobileMenu: false})
    }
  }

  componentDidMount() {
    const cookies = new Cookies();
    const cookieVouchers = cookies.get("vouchers");
    const status = (cookieVouchers && cookieVouchers != 'null' && cookieVouchers.length > 0) ? true : false;
    this.setState({bookingCheckout: !status , backLink: !status ? "/reserver/" : "/carte-cadeaux/"});
  }

  render() {
    const {intl:{formatMessage}} = this.props

    return (
      <div className="cart-container">
        <Helmet>
          <title>{formatMessage(messages.pageTitle)}</title>
        </Helmet>
        <div
          className="navbar navbar-sticky navbar-booking navbar-cart"
          style={this.state.mobileMenu ? {} : bookingStyle}>
          <div className="cart-book-back"><a href={this.state.backLink}><i className="arrow left"></i> {this.state.bookingCheckout ? formatMessage(messages.bookAnotherGame) : formatMessage(messages.bookAnotherGift)}</a></div>
          {
            !this.state.mobileMenu
            ? <h1>{formatMessage(messages.title)}</h1>
            : null
          }
        </div>
        <Cart
          lang={this.props.lang}
          expiration={() => this.props.handleExpiration()}
          />
        <MobileMenu />
      </div>
    )
  }
}

const messages = defineMessages({
  pageTitle: {
    id: 'cartContainer.pageTitle',
    defaultMessage: 'Panier - One Hour'
  },
  title: {
    id: 'cartContainer.title',
    defaultMessage: 'Réservation'
  },
  bookAnotherGame: {
    id: 'cartContainer.bookAnotherGame',
    defaultMessage: "Revenir au calendrier de réservation"
  },
  bookAnotherGift: {
    id: 'cartContainer.bookAnotherGift',
    defaultMessage: "Prendre une autre carte cadeaux"
  },
})

export default injectIntl(CartContainer)



// WEBPACK FOOTER //
// ./src/components/CartContainer.js